<template>
    <div
        v-if="isHome"
        style="margin: auto"
        class="card-price"
        key="body"
    >
        <span
            class="display-2"
            :style="{ color: settings.card_text_color }"
        >
            {{ settings.show_value ? planValue : '' }}
        </span>
        <div v-if="isRecurrent">
            <span :style="{ color: settings.card_text_color }">
                {{ recurrenceLabel }}
            </span>
        </div>
    </div>
    <div v-else>
        <span
            class="display-2"
            :style="{ color: color.secondary }"
        >
            {{ layout.show_value ? planValue : '' }}
        </span>
        <div v-if="isRecurrent">
            <span :style="{ color: color.secondary }">
                {{ recurrenceLabel  }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        plan: {
            type: Object,
        },
        content: {
            type: Object,
        },
        isHome: {
            type: Boolean,
        },
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        layout() {
            return this.plan.layout;
        },
        settings() {
            return this.content && this.content.settings;
        },
        isRecurrent() {
            return this.plan.type === 4;
        },
        recurrenceLabel() {
            return this.plan.recurrenceOption && this.plan.recurrenceOption.short_label;
        },
        planValue() {
            switch (this.plan.type) {
            case 1:
                return this.$t('common.free');
            case 2:
                return this.$t('common.public');
            case 3:
                return this.plan.price;
            case 4:
                return this.plan.price;
            default:
                return null;
            }
        },
    },
};
</script>
